import { render, staticRenderFns } from "./BloggerRankingLoadingContainer.vue?vue&type=template&id=f8c3281a&"
import script from "./BloggerRankingLoadingContainer.vue?vue&type=script&lang=js&"
export * from "./BloggerRankingLoadingContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports